import Image from 'next/image'
import Button from '@shared/components/Button/Button'
import { Stack, Clamp, Row } from '@christiankaindl/lyts'
import { type FC } from 'react'
import * as styles from './Footer.css'
import { Instagram, Linkedin } from 'lucide-react'
import Link from 'next/link'
import codaraLogo from '@/public/assets/codara-favicon.png'
import logoHorizontalAT from '@shared/assets/gesetzefinden-at-logo-horizontal.png'
import logoHorizontalDE from '@shared/assets/gesetzefinden-de-logo-horizontal.png'
import { isDeJurisdiction } from '@shared/lib/jurisdiction'
import { pathMappings } from '@shared/lib/paths'

const logo = isDeJurisdiction ? logoHorizontalDE : logoHorizontalAT

const Footer: FC = function () {
  return (
    <Clamp asChild clamp='900px' className={styles.root}>
      <footer>
        <Row expandChildren wrap gap={3} yAlign='start' xAlign='center'>
          <Stack gap={0.25} xAlign='center'>
            <Image
              src={logo}
              alt='Logo'
              style={{ height: 32, width: 'auto' }}
              priority
            />
          </Stack>
          <Row gap={2} wrap yAlign='start' xAlign='center'>
            <Stack gap={0.5}>
              <Row gap={0.5} asChild xAlign='start'>
                <Link
                  href='https://codara.com'
                  target='_blank'
                  style={{ paddingLeft: 9, width: 'fit-content' }}
                >
                  <Image
                    src={codaraLogo}
                    width={20}
                    height={20}
                    alt='Codara'
                    style={{ borderRadius: 5 }}
                  />
                  <b>Codara</b>
                </Link>
              </Row>
              <Button
                href='https://codara.com/produkte/regulatory-monitoring'
                target='_blank'
                variant='flat'
                size='small'
              >
                Regulatory Monitoring
              </Button>
              <Button
                href='https://codara.com/produkte/judikatur-monitoring'
                target='_blank'
                variant='flat'
                size='small'
              >
                Judikatur Monitoring
              </Button>
              {/* TODO: Add page for regulatory radar */}
              <Button
                href='https://codara.com/produkte/regulatory-radar'
                variant='flat'
                size='small'
              >
                Legislative Radar
              </Button>
              <hr style={{ marginLeft: 9 }} />
              <Button
                href='https://codara.com/kontakt'
                target='_blank'
                variant='flat'
                size='small'
              >
                Kontakt
              </Button>
              <Button
                href='https://codara.com/ressourcen#case-studies'
                target='_blank'
                variant='flat'
                size='small'
              >
                Case Studies
              </Button>
              <Button
                href='https://codara.com/ressourcen#events'
                target='_blank'
                variant='flat'
                size='small'
              >
                Events
              </Button>
            </Stack>

            <Stack gap={0.5}>
              <span style={{ paddingLeft: 9 }}>
                <b>Plattform</b>
              </span>
              {Object.entries(pathMappings).map(([key, { name }]) => (
                <Button key={key} href={`/${key}`} variant='flat' size='small'>
                  {name}
                </Button>
              ))}
              <hr style={{ marginLeft: 9 }} />
              <Button href='/ueber-uns' variant='flat' size='small'>
                Über uns
              </Button>
              <Button href='/team' variant='flat' size='small'>
                Team
              </Button>
              <Button href='/jobs' variant='flat' size='small'>
                Jobs
              </Button>
            </Stack>
            <Stack gap={0.5}>
              <Button
                href='https://www.linkedin.com/company/gesetzefinden'
                variant='flat'
                size='small'
              >
                <Linkedin size={16} />
                LinkedIn
              </Button>
              <Button
                href='https://www.instagram.com/gesetzefinden.at/'
                variant='flat'
                size='small'
              >
                <Instagram size={16} />
                Instagram
              </Button>
              <hr style={{ marginLeft: 9 }} />
              <Button
                href='/agb'
                variant='flat'
                size='small'
                title='Allgemeine Geschäftsbedingungen'
              >
                AGB
              </Button>
              <Button href='/datenschutz' variant='flat' size='small'>
                Datenschutzerklärung
              </Button>
              <Button href='/impressum' variant='flat' size='small'>
                Impressum
              </Button>
              <Button href='/haftungsausschluss' variant='flat' size='small'>
                Haftungsausschluss
              </Button>
            </Stack>
          </Row>
        </Row>
      </footer>
    </Clamp>
  )
}

export default Footer
